import { useRoutes, Navigate } from 'react-router-dom';
import MaterialWizard from './components/wizard/MaterialWizard';
import MaterialesCreados from './components/MaterialesCreados/MaterialesCreados';
import Login from './page/Login';
import Configuracion from './page/Configuracion';
import { useAuth } from './context/AuthContext';

function ProtectedRoute({ children }) {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    return children;
}

function AdminRoute({ children }) {
    const { isAuthenticated, user } = useAuth();
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (user?.rol !== 'admin') return <Navigate to="/" replace />;
    return children;
}

export default function Router() {
    const { isAuthenticated } = useAuth();

    return useRoutes([
        {
            path: "/login",
            element: isAuthenticated ? <Navigate to="/" replace /> : <Login />,
        },
        {
            path: "/",
            element: <ProtectedRoute><MaterialWizard /></ProtectedRoute>,
        },
        {
            path: "/materiales-creados",
            element: <ProtectedRoute><MaterialesCreados /></ProtectedRoute>,
        },
        {
            path: "/configuracion",
            element: <AdminRoute><Configuracion /></AdminRoute>,
        },
        {
            path: "*",
            element: <Navigate to="/" replace />,
        }
    ]);
}
